import React from 'react'
import withAnimation from '../../../hooks/withAnimation'
import { Link } from 'react-router-dom'
import { routeNames } from '../../../routes/routeNames'
import {  getSpecById } from '../../../utils/Data'

const SpecialtiesServices = ({specailities = []}) => {

    
    return    <section className="bg-white py-12">
        <div className="container mx-auto px-4">
          <h2 className="text-5xl text-primary pb-4 font-bold text-center mb-8">Our Specailities</h2>
          <p className="text-center text-lg mb-12">Find the care you need to achieve your goals.</p>
          <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 overflow-hidden transition-max-height duration-500 ease-in-out max-h-full`}>
            {specailities.map((spec, index) => (
              <Link to={`/specialities/${spec.id}`}>
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden transition transform duration-500 ease-in-out hover:-translate-y-1 hover:scale-105">
                <img src={spec.image} alt={spec.title} className="w-full h-48 object-cover" />
                <div className="p-6">
                  <h3 className="text-xl font-bold mb-2">{spec.title}</h3>
                  <p className="text-gray-600">{spec.captionDescription}</p>
                </div>
              </div>
              </Link>
            ))}
          </div>
          
        </div>
      </section>
  }

export default withAnimation(SpecialtiesServices)